import cn from "classnames";
import { useTranslation } from "react-i18next";

import styles from "./PersonalOrderBadge.module.scss";

interface PersonalOrderBadgeProps {
  className?: string;
}

/**
 * Without this, a reseller order showing zero commission and zero margin looks
 * like broken data — it is simply an order the reseller bought for themselves,
 * where the commission was deducted from the price up front instead.
 */
export const PersonalOrderBadge = ({ className }: PersonalOrderBadgeProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(styles.personalOrderBadge, className)}
      title={t(
        "The reseller bought this order for themselves — no commission and no payout; the commission was deducted from the price"
      )}
    >
      {t("PERSONAL")}
    </div>
  );
};

export default PersonalOrderBadge;
